export default {
  SET_SUMMARY_BATCH_REQUEST(state, payload) {
    state.summaryBatchRequests = payload;
  },
  BATCH_REQUEST_MODAL(state, payload) {
    state.batchRequestModal = payload;
  },
};
